import classNames from 'classnames';
import React from 'react';
import { history } from 'umi';

const Logo: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div
    className={classNames(
      'mr-4 box-border flex cursor-pointer select-none items-center justify-center',
      className,
    )}
    onClick={() => history.push('/')}
  >
    <img className="h-[30px] w-[30px] rounded-[30%]" src="/images/logo.png" />
    <div className="ml-2 hidden flex-col md:flex">
      <span className="text-[18px] font-[800] leading-[24px]">Guanyun</span>
      <span className="text-[12px] leading-[16px] text-secondary">观云旗舰店小程序</span>
    </div>
  </div>
);

export default Logo;
